var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "save-search-form" },
    [
      _c("p", [_vm._v("\n        " + _vm._s(_vm.lang.sentence) + "\n    ")]),
      _vm._v(" "),
      _c("tecno-map", {
        ref: "map",
        staticClass: "tecnomap-container",
        attrs: { options: _vm.options, section: _vm.section }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "search-title" }, [
        _vm._v("\n        " + _vm._s(_vm.title) + "\n    ")
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "badges" },
        _vm._l(_vm.filters, function(param, key) {
          return _c(
            "span",
            {
              key: key,
              class:
                "badge badge-" +
                _vm.$root.network +
                "-" +
                (key.substring(0, key.indexOf("|"))
                  ? key.substring(0, key.indexOf("|"))
                  : key)
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm._f("capitalize")(param.title)) +
                  "\n        "
              )
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "form",
        {
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.saveSearch.apply(null, arguments)
            },
            keydown: function($event) {
              return _vm.form.errors.clear($event.target.name)
            }
          }
        },
        [
          _vm.is_guest()
            ? _c("my-input", {
                attrs: {
                  name: "email",
                  type: "email",
                  label: _vm.lang.labels.email
                },
                model: {
                  value: _vm.form.email,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "email", $$v)
                  },
                  expression: "form.email"
                }
              })
            : _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.email,
                    expression: "form.email"
                  }
                ],
                attrs: { type: "hidden" },
                domProps: { value: _vm.form.email },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.form, "email", $event.target.value)
                  }
                }
              }),
          _vm._v(" "),
          _c("error-span", { attrs: { error: _vm.form.errors.get("email") } }),
          _vm._v(" "),
          _c("div", {
            staticClass: "privacy-policy",
            domProps: { innerHTML: _vm._s(_vm.lang.privacy_policy) }
          }),
          _vm._v(" "),
          _c("marketing-checkbox", {
            attrs: { lang: _vm.lang },
            model: {
              value: _vm.form.marketing,
              callback: function($$v) {
                _vm.$set(_vm.form, "marketing", $$v)
              },
              expression: "form.marketing"
            }
          }),
          _vm._v(" "),
          _c("error-span", {
            attrs: { error: _vm.form.errors.get("marketing") }
          }),
          _vm._v(" "),
          _c("button", { staticClass: "btn btn-network" }, [
            _vm._v(
              "\n            " + _vm._s(_vm.lang.labels.save) + "\n        "
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }